import { handleActions } from 'redux-actions';
import { reduxKey } from './constants';
import { AppEnvironment } from './types';

const handler = handleActions<AppEnvironment, any>({}, {} as any);

const reducers = {
  [`${reduxKey}`]: handler,
};

export default reducers;
